/**
 *  Cart drawer behaviour that the theme does not provide.
 *
 *  1. Stepping the quantity below 1 removes the line, so the drawer needs no
 *     separate delete control. The theme's QuantityInput hard-clamps with
 *     `Math.max(quantity, 1)` and ignores min="0", so the minus button has to
 *     be intercepted before that listener runs.
 *
 *  2. The Latvijas Pasts app renders its picker in English. The cart page has
 *     its own translation pass in main-cart.liquid; the drawer had none.
 *
 *  Both are delegated / observed rather than bound once, because the drawer is
 *  replaced wholesale by the Section Rendering API on every cart change and the
 *  shipping picker is injected asynchronously.
 */

(function () {
  var DRAWER = '#Cart-Drawer';

  /* ---- 1. Minus at quantity 1 removes the line ---------------------------- */

  // Capture phase: this has to beat QuantityInput's own click listener, which
  // is bound directly to the button and would otherwise clamp back up to 1.
  document.addEventListener(
    'click',
    function (event) {
      var minus = event.target.closest ? event.target.closest(DRAWER + ' quantity-selector .minus') : null;
      if (!minus) return;

      var selector = minus.closest('quantity-selector');
      var input = selector && selector.querySelector('.qty');
      if (!input || parseInt(input.value, 10) > 1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      // Reuse the theme's own remove link: CartDrawer has already wired it to
      // updateQuantity(line, 0) and rebinds it after every re-render.
      var row = selector.closest('.product-cart-item');
      var remove = row && row.querySelector('.remove');
      if (remove) remove.click();
    },
    true
  );

  /* ---- 2. Keep the shipping picker across drawer re-renders --------------- */

  // Any cart edit re-renders the drawer through the Section Rendering API,
  // which replaces #Cart-Drawer's children wholesale. The Latvijas Pasts app
  // injects its picker once on load and guards re-entry with
  // window.__latviaPostShippingInitialized, exposing no re-init hook — so once
  // the re-render discards its markup, nothing puts it back and the customer
  // has no way to choose a shipping method short of reloading.
  //
  // The node is therefore preserved rather than recreated: held across the
  // swap and re-attached afterwards, so the app's own listeners and the
  // customer's current selection survive intact.
  var PICKER_ID = 'latvia-post-shipping';
  var savedPicker = null;

  function drawer() {
    return document.getElementById('Cart-Drawer');
  }

  function syncPicker() {
    var root = drawer();
    if (!root) return;

    var live = document.getElementById(PICKER_ID);
    if (live) {
      // Still present — keep the reference fresh for the next swap.
      savedPicker = live;
      return;
    }
    if (!savedPicker) return;

    var buttons = root.querySelector('.cart-drawer-buttons');
    if (buttons) buttons.appendChild(savedPicker);
  }

  /* ---- 3. Latvian labels for the shipping picker -------------------------- */

  var TRANSLATIONS = {
    'Select shipping method': 'Izvēlies piegādes veidu',
    'Other': 'Omniva vai cits',
    'Pasts': 'Pasts',
    'Select country': 'Izvēlies valsti',
    'Select Pasts shipping method': 'Izvēlies Latvijas Pasta piegādes veidu',
    'Select shipping location': 'Izvēlies pakomātu'
  };

  function isLatvian() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('lv') === 0;
  }

  // Qualifiers rendered as a smaller second line, so the option stays readable
  // without forcing the two pills apart. Naturally idempotent: once applied the
  // node's text no longer matches the key.
  var NOTES = {
    'Pasts': 'lētākais jūsu lokācijā'
  };

  function translate() {
    var root = document.querySelector(DRAWER + ' #latvia-post-shipping');
    if (!root) return;
    var nodes = root.querySelectorAll('.latvia-post-form-group-title, .latvia-post-radio-name');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var key = node.textContent.trim();

      if (NOTES[key] && !node.querySelector('.lp-note')) {
        var label = TRANSLATIONS[key] || key;
        node.textContent = label;
        var note = document.createElement('span');
        note.className = 'lp-note';
        note.textContent = '(' + NOTES[key] + ')';
        node.appendChild(note);
        continue;
      }

      if (TRANSLATIONS[key]) node.textContent = TRANSLATIONS[key];
    }
  }

  function start() {
    // The picker must be preserved regardless of storefront language, so this
    // runs before the Latvian-only label pass returns.
    syncPicker();
    document.addEventListener('cart-drawer:open', syncPicker);

    if (!isLatvian()) {
      new MutationObserver(syncPicker).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
      return;
    }
    translate();
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // setTimeout rather than requestAnimationFrame: rAF is paused in hidden
      // tabs, so a cart edit made before the tab is brought back would never
      // restore the picker.
      setTimeout(function () {
        scheduled = false;
        syncPicker();
        translate();
      }, 0);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // The app rewrites its own labels after mounting, which can land after the
    // observer's pass. Re-apply a few times over the first few seconds.
    var tries = 0;
    var retry = setInterval(function () {
      translate();
      if (++tries > 20) clearInterval(retry);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
